export const BACKEND_BASE_URL: string = process.env.REACT_APP_BACKEND_BASE_URL ?? '';